import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { TransportPlannerProfileItemFacade } from './transport-planner-profile-item.facade';

@Injectable({
  providedIn: 'root',
})
export class TransportPlannerProfileItemGuard {
  constructor(private transportPlannerProfileItemFacade: TransportPlannerProfileItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { transportPlannerProfileId },
    } = route;
    return checkStoreState(this.transportPlannerProfileItemFacade, transportPlannerProfileId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.transportPlannerProfileItemFacade);
  }
}
